/* Site footer (2026-10): newsletter, back to top, footer-in-view flag. Accordions: sections/footer.liquid. ES5 only. */
(function () {
  var w = window, doc = document, root = doc.documentElement;
  if (w.__hmFooterInit) return;
  w.__hmFooterInit = w.hmFooterNewsletterReady = true;
  var EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function $(id) { return doc.getElementById(id); }

  // shared HubSpot helper
  w.hmHubspotSubmit = function (portalId, formGuid, fields, context) {
    return fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + portalId + '/' + formGuid, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ fields: fields, context: context })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        data = data || {};
        if (res.ok && data.status !== 'error' && !data.errors) return data; // inlineMessage/redirectUri = success
        var err = new Error('HubSpot submission failed (' + res.status + ')');
        err.data = data;
        throw err;
      });
    });
  };

  function setError(msg, invalid) { // '' clears
    var err = $('FooterNewsletterError'), input = $('FooterNewsletterEmail');
    if (err) { err.textContent = msg || ''; err.hidden = !msg; }
    if (input) { if (msg && invalid) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
  }
  function announce(msg) {
    var s = doc.querySelector('[data-footer-status]');
    if (s) { s.textContent = ''; setTimeout(function () { s.textContent = msg || ''; }, 100); }
  }
  function leaveGuard(e) { e.preventDefault(); e.returnValue = ''; }

  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.hasAttribute || !form.hasAttribute('data-footer-newsletter')) return;
    e.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return; // in flight
    function msg(name) { return form.getAttribute('data-msg-' + name); }
    var input = $('FooterNewsletterEmail'), email = input ? input.value.replace(/^\s+|\s+$/g, '') : '';
    var btn = form.querySelector('[type="submit"]'), label = btn ? btn.textContent : '';
    if (!EMAIL_RX.test(email)) {
      setError(msg('invalid'), true);
      if (input) input.focus();
      return;
    }
    setError('');
    form.setAttribute('aria-busy', 'true');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = msg('busy') || label; }
    w.addEventListener('beforeunload', leaveGuard);
    var hutk = doc.cookie.match(/(?:^|;\s*)hubspotutk=([^;]*)/);
    var context = { pageUri: location.href, pageName: doc.title };
    if (hutk) context.hutk = hutk[1];
    function settle(err) {
      w.removeEventListener('beforeunload', leaveGuard);
      form.removeAttribute('aria-busy');
      if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; }
      if (err) {
        try { if (w.Bugsnag && typeof w.Bugsnag.notify === 'function') w.Bugsnag.notify(err, function (ev) { ev.context = 'footer-newsletter'; }); } catch (x) {}
        setError(msg('error'));
        announce(msg('error'));
        if (btn) { try { btn.focus(); } catch (x) {} } // Safari does not focus buttons on click: keep focus at the retry point
        return;
      }
      var ra = w.rudderanalytics, ok = $('FooterNewsletterSuccess');
      try {
        if (ra && typeof ra.identify === 'function') ra.identify(email);
        if (ra && typeof ra.track === 'function') ra.track('Newsletter Subscribed', { source: 'footer', category: 'newsletter', name: 'footer' });
      } catch (x) {}
      try { localStorage.setItem('hameray_popup_dismissed_submitted', String(Date.now())); } catch (x) {}
      ['popup-tab', 'popup-overlay'].forEach(function (id) { if ($(id)) $(id).classList.remove('show'); });
      form.hidden = true;
      if (ok) { ok.hidden = false; if (ok.querySelector('h3')) ok.querySelector('h3').focus(); }
      announce(msg('success'));
    }
    try {
      w.hmHubspotSubmit(form.getAttribute('data-portal-id'), form.getAttribute('data-form-guid'), [{ name: 'email', value: email }], context)
        .then(function () { settle(); }, function (err) { settle(err || new Error('HubSpot')); });
    } catch (err) {
      settle(err);
    }
  });

  doc.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.id === 'FooterNewsletterEmail' && t.getAttribute('aria-invalid') === 'true') setError('');
  });

  // Back to top
  doc.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el !== doc && !(el.nodeType === 1 && el.hasAttribute('data-footer-top'))) el = el.parentNode;
    if (!el || el === doc) return;
    e.preventDefault();
    var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('scrollBehavior' in root.style) w.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); else w.scrollTo(0, 0);
    var header = $('shopify-section-header-new-8-original') || doc.querySelector('header');
    var items = header ? header.querySelectorAll('a[href], button, input:not([type="hidden"])') : [];
    for (var i = 0; i < items.length; i++) {
      el = items[i];
      if (!el.disabled && el.getClientRects().length && w.getComputedStyle(el).visibility !== 'hidden') {
        try { el.focus({ preventScroll: true }); } catch (x) { el.focus(); }
        return;
      }
    }
  });

  // html.footer-in-view hides the popup tab (footer.css)
  var observer;
  function flag(on) { root.classList[on ? 'add' : 'remove']('footer-in-view'); }
  function watchFooter() {
    if (!('IntersectionObserver' in w)) return;
    if (observer) observer.disconnect();
    flag(false);
    var footer = doc.querySelector('[data-site-footer]');
    if (!footer) return;
    observer = new IntersectionObserver(function (entries) {
      var en = entries[entries.length - 1];
      flag(en.isIntersecting || en.intersectionRatio > 0);
    });
    observer.observe(footer);
  }
  watchFooter();
  doc.addEventListener('shopify:section:load', watchFooter);
})();
